document.addEventListener("DOMContentLoaded", function(event) {

    /*
     * Menu
     */

    const menuButton = document.querySelector('.mobile-menu-button');
    const toggleClass = 'active-menu';

    menuButton.addEventListener('click', function (event) {

        const offsetParent = this.offsetParent.offsetParent.offsetParent;

        if (this.classList.contains('close')) {

            /*
             *  Opening
             */

            offsetParent.classList.add(toggleClass);

        } else {

            /*
             * Closing
             */

            offsetParent.classList.remove(toggleClass);
        }

    });

    /*
     * Search
     */

    const searchButtonTrigger = document.querySelector('.trigger-overlay.search-icon');
    const fakeSearchButtons = document.querySelectorAll('.search-trigger');

    for (i = 0; fakeSearchButtons.length > i; i++) {

        fakeSearchButtons[i].addEventListener('click', function (event) {
            event.stopPropagation();
            searchButtonTrigger.click();
        });
    }
});
